import dayjs from "dayjs";

export const DATE_FORMAT = "YYYY-MM-DD";

export function defaultGamification() {
    return {
        posts: {
            with_photo: { points: 1000, daily_limit: 3 },
            only_text: { points: 20, daily_limit: 1 },
        },
        activity: { points: 1500, daily_limit: 2 },
        interactions: { like: 1, comment: 2 },
    };
}

export function defaultInterval() {
    const today = dayjs();
    return {
        start_date: today.format(DATE_FORMAT),
        end_date: today.add(21, "day").format(DATE_FORMAT),
    };
}

export function isFilledLink(link) {
    return !!(link?.title?.trim() || link?.url?.trim());
}

export function isValidHttpUrl(str) {
    if (!str?.trim()) return false;
    try {
        const u = new URL(str.trim());
        return u.protocol === "http:" || u.protocol === "https:";
    } catch {
        return false;
    }
}

// `t` is injected by the caller so the messages follow the active language.
export function validateConfig(cfg, t) {
    const errors = {};
    let valid = true;

    if (!cfg?.name?.trim()) {
        errors.name = t("manageGroup.validation.name");
        valid = false;
    }

    if (Array.isArray(cfg?.plans) && cfg.plans.length === 0) {
        errors.plans = t("manageGroup.validation.plans");
        valid = false;
    }

    const links = cfg?.links || [];
    const linkErrors = {};
    links.forEach((link, i) => {
        if (!isFilledLink(link)) return;
        const e = {};
        if (!link?.title?.trim()) e.title = t("manageGroup.validation.linkTitle");
        if (!link?.url?.trim()) {
            e.url = t("manageGroup.validation.linkUrl");
        } else if (!isValidHttpUrl(link.url)) {
            e.url = t("manageGroup.validation.invalidUrl");
        }
        if (Object.keys(e).length > 0) {
            linkErrors[i] = e;
            valid = false;
        }
    });
    if (Object.keys(linkErrors).length > 0) errors.links = linkErrors;

    if (cfg?.type === "CHALLENGE") {
        const start = cfg?.interval?.start_date
            ? dayjs(cfg.interval.start_date)
            : null;
        const end = cfg?.interval?.end_date
            ? dayjs(cfg.interval.end_date)
            : null;

        if (!start?.isValid()) {
            errors.startDate = t("manageGroup.validation.startDate");
            valid = false;
        } else if (start.startOf("day").isBefore(dayjs().startOf("day"))) {
            errors.startDate = t("manageGroup.validation.startDateInPast");
            valid = false;
        }
        if (!end?.isValid() || (start?.isValid() && !end.isAfter(start))) {
            errors.endDate = t("manageGroup.validation.duration");
            valid = false;
        }

        const g = cfg?.gamification;
        if (
            !g ||
            !g.posts?.with_photo ||
            !g.posts?.only_text ||
            !g.activity ||
            !g.interactions
        ) {
            errors.gamification = t("manageGroup.validation.gamification");
            valid = false;
        }

        const awards = cfg?.awards || [];
        const awardErrors = {};
        awards.forEach((award, i) => {
            const e = {};
            if (!award?.title?.trim()) e.title = t("manageGroup.validation.awardTitle");
            if (Object.keys(e).length > 0) {
                awardErrors[i] = e;
                valid = false;
            }
        });
        if (Object.keys(awardErrors).length > 0) errors.awards = awardErrors;
    }

    return { isValid: valid, errors };
}

export function clearErrorPath(errors, path) {
    if (!errors || Object.keys(errors).length === 0) return errors;
    const segments = path.split(".");
    const next = { ...errors };
    let cursor = next;
    for (let i = 0; i < segments.length - 1; i++) {
        const k = segments[i];
        if (cursor[k] === undefined) return errors;
        cursor[k] = Array.isArray(cursor[k]) ? [...cursor[k]] : { ...cursor[k] };
        cursor = cursor[k];
    }
    const leaf = segments[segments.length - 1];
    if (cursor[leaf] === undefined) return errors;
    delete cursor[leaf];
    return next;
}
